<template>
  <div class="animated fadeInRight padding">
    <el-row :gutter="20">
      <el-col v-if="showParkingCommunityColumn" :span="4">
        <select-admin-community
          :allow-all="false"
          :community-options="parkingCommunities"
          @changeCommunity="handleChangeCommunity" />
      </el-col>
      <el-col :span="showParkingCommunityColumn ? 20 : 24">
    <el-alert
      v-if="contextReady && !hasCommunityContext"
      :title="emptyContextMessage"
      type="info"
      :closable="false"
      show-icon
      class="context-alert" />
    <el-card class="box-card">
      <div slot="header">
        <span>临停缴费记录</span>
      </div>
      <el-form :inline="true" :model="conditions">
        <el-form-item label="车牌号">
          <el-input v-model.trim="conditions.plateNumber" maxlength="8"
            placeholder="请输入完整车牌" clearable />
        </el-form-item>
        <el-form-item label="微信状态">
          <el-select v-model="conditions.paymentState" clearable placeholder="全部">
            <el-option label="待支付" value="CREATED" />
            <el-option label="支付中" value="PAYING" />
            <el-option label="已支付" value="PAID" />
            <el-option label="免费" value="FREE" />
            <el-option label="已取消" value="CANCELLED" />
          </el-select>
        </el-form-item>
        <el-form-item label="停车场通知">
          <el-select v-model="conditions.notifyState" clearable placeholder="全部">
            <el-option label="等待付款" value="WAITING_PAYMENT" />
            <el-option label="待通知" value="PENDING" />
            <el-option label="通知中" value="PROCESSING" />
            <el-option label="重试中" value="RETRY" />
            <el-option label="已完成" value="COMPLETED" />
            <el-option label="无需通知" value="NOT_REQUIRED" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="dateRange" type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="!hasCommunityContext"
            @click="queryOrders">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card table-card">
      <el-table v-loading="loading" :data="orders" border style="width:100%">
        <el-table-column prop="orderId" label="本地订单号" min-width="220" />
        <el-table-column prop="communityName" label="小区" min-width="140" />
        <el-table-column prop="plateNumber" label="车牌" width="110" align="center" />
        <el-table-column label="缴费场景" width="100" align="center">
          <template slot-scope="scope">
            {{ Number(scope.row.payScene) === 1 ? '出口扫码' : '提前缴费' }}
          </template>
        </el-table-column>
        <el-table-column label="出口" min-width="130">
          <template slot-scope="scope">
            {{ Number(scope.row.payScene) === 1
              ? (scope.row.outChannelName || scope.row.outChannelId || '--')
              : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="inParkTime" label="进场时间" width="165" />
        <el-table-column label="停车时长" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.parkHourMinutes }} 分钟</template>
        </el-table-column>
        <el-table-column label="金额" width="100" align="right">
          <template slot-scope="scope">¥{{ centsToYuan(scope.row.payableMoneyCents) }}</template>
        </el-table-column>
        <el-table-column label="微信状态" width="105" align="center">
          <template slot-scope="scope">
            <el-tag :type="paymentTag(scope.row.paymentState)" size="small">
              {{ paymentText(scope.row.paymentState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="paidTime" label="付款时间" width="165" />
        <el-table-column label="9.9通知状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="notifyTag(scope.row.notifyState)" size="small">
              {{ notifyText(scope.row.notifyState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="notifyTime" label="通知成功时间" width="165" />
        <el-table-column label="脱敏错误" min-width="180">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.lastError" :content="scope.row.lastError"
              placement="top">
              <span class="error-text">{{ scope.row.lastError }}</span>
            </el-tooltip>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page="pagination.current"
        :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" class="pagination" />
    </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listParking99TempOrders } from '@/api/car/tempCarPaymentApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getStoreInfo } from '@/api/user/indexApi'
import { listParking99Channels } from '@/api/car/parking99GateControlApi'
import SelectAdminCommunity from '@/components/community/selectAdminCommunity'

export default {
  name: 'TempCarPaymentList',
  components: {
    SelectAdminCommunity
  },
  data() {
    return {
      loading: false,
      orders: [],
      dateRange: [],
      communityId: '',
      contextReady: false,
      showCommunitySelector: false,
      parkingCommunities: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      conditions: {
        plateNumber: '',
        paymentState: '',
        notifyState: ''
      }
    }
  },
  computed: {
    hasCommunityContext() {
      return Boolean(this.communityId && this.communityId !== '-1')
    },
    showParkingCommunityColumn() {
      return this.showCommunitySelector && this.parkingCommunities.length > 0
    },
    emptyContextMessage() {
      if (!this.parkingCommunities.length) {
        return '当前账号没有可访问且已启用的停车配置'
      }
      return this.showCommunitySelector
        ? '请先在左侧选择已接入停车平台的小区'
        : '当前小区尚未接入或未启用停车配置'
    }
  },
  created() {
    this.initializeCommunityContext()
  },
  methods: {
    async initializeCommunityContext() {
      try {
        const store = await getStoreInfo()
        this.showCommunitySelector = [
          '800900000000',
          '800900000001'
        ].includes(store.storeTypeCd)
        await this.loadParkingCommunities()
        if (!this.showCommunitySelector) {
          const currentCommunityId = getCommunityId()
          this.communityId = this.parkingCommunities.some(
            item => item.communityId === currentCommunityId
          ) ? currentCommunityId : ''
        }
      } catch (error) {
        this.$message.error(error.message || '当前商户信息加载失败')
      } finally {
        this.contextReady = true
      }
      if (this.hasCommunityContext) {
        this.queryOrders()
      }
    },
    async loadParkingCommunities() {
      const result = await listParking99Channels()
      const communities = []
      const seen = new Set()
      const configs = result.data || []
      configs.forEach(config => {
        if (config.enabled !== 'Y' || seen.has(config.communityId)) {
          return
        }
        seen.add(config.communityId)
        communities.push({
          communityId: config.communityId,
          name: config.communityName || config.communityId
        })
      })
      this.parkingCommunities = communities
    },
    handleChangeCommunity(community) {
      this.communityId = community && community.communityId
        ? community.communityId : ''
      this.orders = []
      this.pagination.current = 1
      this.pagination.total = 0
      if (this.hasCommunityContext) {
        this.queryOrders()
      }
    },
    async queryOrders() {
      if (!this.hasCommunityContext) {
        this.orders = []
        this.pagination.total = 0
        return
      }
      this.loading = true
      try {
        const response = await listParking99TempOrders({
          ...this.conditions,
          communityId: this.communityId,
          startTime: this.dateRange && this.dateRange[0],
          endTime: this.dateRange && this.dateRange[1],
          page: this.pagination.current,
          row: this.pagination.size
        })
        this.orders = response.data || []
        this.pagination.total = response.total || 0
      } catch (error) {
        this.$message.error(error.message || '查询临停缴费记录失败')
      } finally {
        this.loading = false
      }
    },
    resetQuery() {
      this.conditions = {
        plateNumber: '',
        paymentState: '',
        notifyState: ''
      }
      this.dateRange = []
      this.pagination.current = 1
      this.queryOrders()
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.queryOrders()
    },
    handleCurrentChange(current) {
      this.pagination.current = current
      this.queryOrders()
    },
    centsToYuan(cents) {
      return (Number(cents || 0) / 100).toFixed(2)
    },
    paymentText(state) {
      return {
        CREATED: '待支付',
        PAYING: '支付中',
        PAID: '已支付',
        FREE: '免费',
        CANCELLED: '已取消'
      }[state] || state
    },
    paymentTag(state) {
      return {
        PAID: 'success',
        FREE: 'success',
        CANCELLED: 'info',
        PAYING: 'warning'
      }[state] || ''
    },
    notifyText(state) {
      return {
        WAITING_PAYMENT: '等待付款',
        PENDING: '待通知',
        PROCESSING: '通知中',
        RETRY: '重试中',
        COMPLETED: '已完成',
        NOT_REQUIRED: '无需通知'
      }[state] || state
    },
    notifyTag(state) {
      return {
        COMPLETED: 'success',
        NOT_REQUIRED: 'success',
        RETRY: 'danger',
        PROCESSING: 'warning',
        PENDING: 'warning'
      }[state] || 'info'
    }
  }
}
</script>

<style scoped>
.context-alert {
  margin-bottom: 20px;
}

.table-card {
  margin-top: 20px;
}

.pagination {
  margin-top: 20px;
}

.error-text {
  display: inline-block;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #f56c6c;
}
</style>
